import React, { useContext } from 'react'
import { AuthContext, USER_TYPES } from 'components/common/auth/AuthContext'

export interface HiddenReviewsTextProps {
  procuratedPromisePath: string
}

export const HiddenReviewsText: React.FC<HiddenReviewsTextProps> = ({ procuratedPromisePath }) => {
  const authState = useContext(AuthContext)

  return authState.userType === USER_TYPES.UNAUTHED || authState.userType === USER_TYPES.SUPPLIER_USER
    ? (
      <p>
        Written reviews are only visible to our community of logged-in government users and
        the suppliers the review writers choose to share their reviews with. This creates a
        space where buyers can feel comfortable sharing their honest experiences and to praise
        and provide actionable feedback to their suppliers. For more on this, check out the{' '}
        <a
          href={procuratedPromisePath}
          target='_blank' rel='noreferrer'
        >
          Procurated Promise
        </a>.
      </p>
      )
    : (
      <p>
        An individual review appears on your view of your supplier profile when the author
        explicitly chooses to make their review visible to you. This option creates a space
        where buyers can feel comfortable sharing their honest experiences with each other, and
        consider this as a channel to share praise and actionable feedback with you. For more
        on why we do this, check out the{' '}
        <a
          href={procuratedPromisePath}
          target='_blank'
          rel='noreferrer'
        >
          Procurated Promise
        </a>.
      </p>
      )
}
